import React from 'react'
import { useSelector } from 'react-redux'
import { BasicDropdown, FormLabel } from '../../../components'
import { inputNormalizer } from '../../../utils'
import { useProvinces } from '../hook'

const ProvinceDropdown = ({ defaultValue, updateForm, customLabel, noMarginBottom = false }) => {
  const { options }  = useProvinces()
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)

  return (
    <>
      {
        customLabel ? customLabel : (
          <FormLabel>
            {translation.GENERAL.province[language.name]}
          </FormLabel>
        )
      }
      <BasicDropdown
        placeholder={translation.GENERAL.province_choose[language.name]}
        options={options}
        defaultValue={defaultValue}
        onChange={(e) => inputNormalizer(e, "province", updateForm)}
        noMarginBottom={noMarginBottom}
        // onChange={({ value }) => inputNormalizer(value, "province", updateForm)}
      />
    </>
  )
}

export { ProvinceDropdown }
